import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import VentilstillingFilterForm from "./VentilstillingFilterForm";

import {
    handleChange as handleChangeAction,
    handleChangeAll as handleChangeAllAction,
    handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getVentilstillinger } from "../../../actions/ventilstillingerActions";
import { INITIAL_STATE as VentilstillingFilterFormStateInitial } from "../../../reducers/forms/VentilstillingFilterFormReducer";
import * as inputValidation from "../../../utils/inputValidationUtils";

import { toIsoString } from "../../../utils/date";

function VentilstillingFilterContainer() {
  const dispatch = useDispatch();
  const VentilstillingFilterFormState = useSelector(
    (state) => state.forms.VentilstillingFilterForm,
  );

  const [error, setError] = useState(""); // eslint-disable-line no-unused-vars
  const [
    shallGetVentilstillingDueToHandleChangeToInitState,
    setShallGetVentilstillingDueToHandleChangeToInitState,
  ] = useState(false);
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  useEffect(() => {
    if (
      JSON.stringify(VentilstillingFilterFormState) ===
        JSON.stringify(VentilstillingFilterFormStateInitial) &&
      shallGetVentilstillingDueToHandleChangeToInitState === true
    ) {
      setShallGetVentilstillingDueToHandleChangeToInitState(false);
    }
  });

  const handleChange = (e) => {
    dispatch(
      handleChangeAction("VENTILSTILLING_FILTER_FORM", e.target.name, e.target.value),
    );
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("VENTILSTILLING_FILTER_FORM"));
    setShallGetVentilstillingDueToHandleChangeToInitState(true);
  };

  const resetValidationErrorText = () => {
    dispatch(handleChangeAction("VENTILSTILLING_FILTER_FORM", "fraDatoValidationErrorText", null));
    dispatch(handleChangeAction("VENTILSTILLING_FILTER_FORM", "tilDatoValidationErrorText", null));
  };

  const validate = () => {
    return inputValidation.fraDateTimeTilDateTimeValidation(
      VentilstillingFilterFormState,
      (name, value) => dispatch(handleChangeAction("VENTILSTILLING_FILTER_FORM", name, value)),
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    resetValidationErrorText();
    if (validate()) {
      dispatch(
        handleChangeAllAction("RAPPORT_VENTILSTILLING_SUBMITTED_FORM", {
          fraDato: VentilstillingFilterFormState.fraDato,
          tilDato: VentilstillingFilterFormState.tilDato,
          submitTimestamp: new Date(),
          kjennemerke: VentilstillingFilterFormState.kjennemerke,
        }),
      );
      setShowSokSpinner(true);
      const params = {
        fraDato: toIsoString(VentilstillingFilterFormState.fraDato),
        tilDato: toIsoString(VentilstillingFilterFormState.tilDato),
        kjennemerke: VentilstillingFilterFormState.kjennemerke,
      };
      dispatch(getVentilstillinger(params))
        .then(() => setShowSokSpinner(false))
        .catch(() => setShowSokSpinner(false));
    }
  };

  return (
    <VentilstillingFilterForm
      showSokSpinner={showSokSpinner}
      VentilstillingFilterFormState={VentilstillingFilterFormState}
      handleChange={handleChange}
      handleChangeToInitState={handleChangeToInitState}
      handleSubmit={handleSubmit}
    />
  );
}

export default VentilstillingFilterContainer;
